import React, { useEffect, useState, useRef } from 'react';
import { useMemberstack } from "@memberstack/react";
import { Navbar, TabContent } from 'reactstrap';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loading from '../components/Loading';
import { fetchRecordsFields } from "./utils/airtable";
import { getTabPanesByDemarche } from "./factories/TabPaneFactory";
import { useUserData } from "./hooks/useUserData";

// Styles & Icônes
import icnLogo from '../img/icn-logo.svg';
import { Sidebar, SidebarBody, SidebarFooter, SidebarHeader, SidebarItem, SidebarLabel, SidebarSection, SidebarSpacer } from '../components/catalyst/sidebar';
import { SidebarLayout } from '../components/catalyst/sidebar-layout';
import { ArrowRightStartOnRectangleIcon, ChevronUpIcon, BuildingOfficeIcon, DocumentIcon, HomeIcon, UserIcon, UserCircleIcon, ChatBubbleLeftRightIcon, UsersIcon } from '@heroicons/react/20/solid'
import { Avatar } from '../components/catalyst/avatar';
import { Dropdown, DropdownButton, DropdownDivider, DropdownItem, DropdownLabel, DropdownMenu } from '../components/catalyst/dropdown';


function Layout() {
    const location = useLocation();
    const navigate = useNavigate();
    const memberstack = useMemberstack();
    const [currentActiveTab, setCurrentActiveTab] = useState(null);
    const [selectedTransactionIndex, setSelectedTransactionIndex] = useState(0);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const hasRefreshed = useRef(false);
    const {
        data,
        setData,
        userData,
        transactions
    } = useUserData(memberstack);



    //fonction de load des transactions si plusieurs transactions immo
    const loadTransactionData = async (index, transactionsList = transactions, userData) => {
        //console.log("📌 Chargement des données pour l'index :", index);

        if (!transactionsList[index]) {
            //console.log("❌ Erreur : Aucune transaction trouvée à cet index !");
            return;
        }

        if (!userData || !userData.fields || !userData.fields.transaction || !userData.fields.transaction[index]) {
            //console.log("❌ Erreur : L'ID de la transaction n'existe pas dans userData.");
            return;
        }

        const transactionId = userData.fields.transaction[index];
        //console.log("🆔 ID de la transaction sélectionnée :", transactionId);

        try {
            const bienData = await fetchRecordsFields("bien", transactionId, "transaction");
            //console.log("🏠 Bien récupéré :", bienData);

            const evenementData = await fetchRecordsFields("event", transactionId, "transaction");
            //console.log("📅 Événements récupérés :", evenementData);

            const rdvData = await fetchRecordsFields("rdv", transactionId, "transaction");
            //console.log("📞 Rendez-vous récupérés :", rdvData);

            const actionData = await fetchRecordsFields("actions", transactionId, "transaction");
            //console.log("✅ Actions récupérées :", actionData);

            const documentData = await fetchRecordsFields("document", transactionId, "transaction");
            //console.log("📄 Documents récupérés :", documentData);

            setData({
                ...data, // 👈 on garde les données existantes
                user: userData.fields,
                demarche: "transaction",
                transaction: transactionsList[index],
                bien: bienData,
                evenement: evenementData,
                rdv: rdvData,
                action: actionData,
                document: documentData,
            });


            //console.log("✅ Mise à jour de l'état `data` réussie !");
            setSelectedTransactionIndex(index);
        } catch (error) {
            console.log("❌ Erreur dans loadTransactionData :", error);
        }
    };

    //fonction refresh data
    useEffect(() => {
        console.log("🔄 Changement de route détecté :", location.pathname);
        console.log("🟢 currentActiveTab avant mise à jour :", currentActiveTab);

        const path = location.pathname.replace("/app/", "") || "dashboard";
        setCurrentActiveTab(path);

        console.log("✅ Nouveau currentActiveTab :", path);
    }, [location.pathname]);



    useEffect(() => {
        switch (location.pathname) {
            case "/app/documents":
                setCurrentActiveTab("documents");
                break;
            case "/app/dashboard":
                setCurrentActiveTab("dashboard");
                break;
            case "/app/notaire":
                setCurrentActiveTab("notaire");
                break;
            case "/app/message":
                setCurrentActiveTab("message");
                break;
            case "/app/interlocuteurs":
                setCurrentActiveTab("interlocuteurs");
                break;  
            case "/app/bien":
                setCurrentActiveTab("bien");
                break;
            case "/app/dashboard-pma":
                setCurrentActiveTab("dashboard-pma");
                break;
            case "/app/document-pma":
                setCurrentActiveTab("document-pma");
                break;
            case "/app/notaire-pma":
                setCurrentActiveTab("notaire-pma");
                break;
            case "/app/dashboard-mariage":
                setCurrentActiveTab("dashboard-mariage");
                break;
            case "/app/document-mariage":
                setCurrentActiveTab("document-mariage");
                break;
            case "/app/notaire-mariage":
                setCurrentActiveTab("notaire-mariage");
                break;
                case "/app/dashboard-pacs":
                    setCurrentActiveTab("dashboard-pacs");
                    break;
                case "/app/document-pacs":
                    setCurrentActiveTab("document-pacs");
                    break;
                case "/app/notaire-pacs":
                    setCurrentActiveTab("notaire-pacs");
                    break;
            case "/app/dashboard-empty":
                setCurrentActiveTab("dashboard-empty");
                break;
            case "/app/notaire-empty":
                setCurrentActiveTab("notaire-empty");
                break;
            case "/app/profil":
                setCurrentActiveTab("profil");
                break;
            default:
                setCurrentActiveTab("dashboard");
        }
    }, [location.pathname]);



    const getSidebar = () => {
        if (!data || !data.demarche) return null;

        const navigateTo = (tab) => {
            setCurrentActiveTab(tab);
            navigate(`/app/${tab}`);
        };

        const renderSidebarContent = () => {
            switch (data.demarche) {
                case "transaction":
                case "transaction_vendeur":
                    return (
                        <>

                            <Link to="/app/dashboard" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "dashboard"}>
                                    <HomeIcon />
                                    <SidebarLabel>Tableau de bord</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/bien" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "bien"}>
                                    <BuildingOfficeIcon />
                                    <SidebarLabel>Bien</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/notaire" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "notaire"}>
                                    <UserIcon />
                                    <SidebarLabel>Notaire</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/interlocuteurs" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "interlocuteurs"}>
                                    <UsersIcon />
                                    <SidebarLabel>Contacts</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/documents" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "documents"}>
                                    <DocumentIcon />
                                    <SidebarLabel>Documents</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/message" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "message"}>
                                    <ChatBubbleLeftRightIcon />
                                    <SidebarLabel>Messagerie</SidebarLabel>
                                </SidebarItem>
                            </Link>

                        </>
                    );

                case "donation":
                    return (
                        <>

                            <Link to="/app/dashboard-donation" className='no-underline'>
                                <SidebarItem
                                    onClick={() => navigateTo("dashboardDonation")}
                                    current={currentActiveTab === "dashboard"}
                                >
                                    <HomeIcon />
                                    <SidebarLabel>Tableau de bord</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/document-donation" className='no-underline'>
                                <SidebarItem
                                    onClick={() => navigateTo("documentDonation")}
                                    className={currentActiveTab === "documentDonation" ? "!bg-indigo-600" : ""}
                                >
                                    <DocumentIcon />
                                    <SidebarLabel>Documents</SidebarLabel>
                                </SidebarItem>
                            </Link>
                        </>
                    );

                case "pma":
                    return (
                        <>

                            <Link to="/app/dashboard-pma" className='no-underline'>
                                <SidebarItem
                                    onClick={() => navigateTo("dashboard-pma")}
                                    current={currentActiveTab === "dashboard-pma"}
                                >
                                    <HomeIcon />
                                    <SidebarLabel>Tableau de bord</SidebarLabel>
                                </SidebarItem>
                            </Link>

                            <Link to="/app/notaire-pma" className='no-underline'>
                                <SidebarItem
                                    onClick={() => navigateTo("notaire-pma")}
                                    current={currentActiveTab === "notaire-pma"}
                                >
                                    <UserCircleIcon />
                                    <SidebarLabel>Votre notaire</SidebarLabel>
                                </SidebarItem>
                            </Link>

                            <Link to="/app/document-pma" className='no-underline'>
                                <SidebarItem
                                    onClick={() => navigateTo("document-pma")}
                                    current={currentActiveTab === "document-pma"}
                                >
                                    <DocumentIcon />
                                    <SidebarLabel>Documents</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/message" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "message"}>
                                    <ChatBubbleLeftRightIcon />
                                    <SidebarLabel>Messagerie</SidebarLabel>
                                </SidebarItem>
                            </Link>
                        </>
                    );

                case "mariage":
                    return (
                        <>
                            <Link to="/app/dashboard-mariage" className="no-underline">
                                <SidebarItem current={currentActiveTab === "dashboard-mariage"}>
                                    <HomeIcon />
                                    <SidebarLabel>Tableau de bord</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/notaire-mariage" className="no-underline">
                                <SidebarItem current={currentActiveTab === "notaire-mariage"}>
                                    <UserCircleIcon />
                                    <SidebarLabel>Votre notaire</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/document-mariage" className="no-underline">
                                <SidebarItem current={currentActiveTab === "document-mariage"}>
                                    <DocumentIcon />
                                    <SidebarLabel>Documents</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/message" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "message"}>
                                    <ChatBubbleLeftRightIcon />
                                    <SidebarLabel>Messagerie</SidebarLabel>
                                </SidebarItem>
                            </Link>
                        </>
                    );
                
                    case "pacs":
                    return (
                        <>
                            <Link to="/app/dashboard-pacs" className="no-underline">
                                <SidebarItem current={currentActiveTab === "dashboard-pacs"}>
                                    <HomeIcon />
                                    <SidebarLabel>Tableau de bord</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/notaire-pacs" className="no-underline">
                                <SidebarItem current={currentActiveTab === "notaire-pacs"}>
                                    <UserCircleIcon />
                                    <SidebarLabel>Votre notaire</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/document-pacs" className="no-underline">
                                <SidebarItem current={currentActiveTab === "document-pacs"}>
                                    <DocumentIcon />
                                    <SidebarLabel>Documents</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/message" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "message"}>
                                    <ChatBubbleLeftRightIcon />
                                    <SidebarLabel>Messagerie</SidebarLabel>
                                </SidebarItem>
                            </Link>
                        </>
                    );
                
                    case "aucune_demarche":
                    return (
                        <>
                            <Link to="/app/dashboard-empty" className="no-underline">
                                <SidebarItem current={currentActiveTab === "dashboard-empty"}>
                                    <HomeIcon />
                                    <SidebarLabel>Tableau de bord</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/notaire-empty" className="no-underline">
                                <SidebarItem current={currentActiveTab === "notaire-mariage"}>
                                    <UserCircleIcon />
                                    <SidebarLabel>Votre notaire</SidebarLabel>
                                </SidebarItem>
                            </Link>
                            <Link to="/app/message" className='no-underline'>
                                <SidebarItem current={currentActiveTab === "message"}>
                                    <ChatBubbleLeftRightIcon />
                                    <SidebarLabel>Messagerie</SidebarLabel>
                                </SidebarItem>
                            </Link>
                        </>
                    );
            }
        };

        return (
            <Sidebar>
                <SidebarHeader>
                    <Dropdown>
                        <DropdownButton as={SidebarItem} className="mb-2.5">
                            <Avatar src={icnLogo} alt="Clotere" />
                            <SidebarLabel>Clotere</SidebarLabel>
                        </DropdownButton>
                    </Dropdown>
                    {/** affichage du bouton de switch affaire */}
                    {userData && transactions && transactions.length > 1 && (
                        <div className="z-50 relative inline-block text-left mb-4">
                            <p className='text-md font-bold'>Sélectionner votre affaire</p>
                            <div>
                                <button
                                    type="button"
                                    className="inline-flex w-full justify-between rounded-md border border-gray-300 bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:text-white shadow-sm hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                >
                                    {transactions[selectedTransactionIndex]?.nom || `Transaction ${selectedTransactionIndex + 1}`}
                                    <svg
                                        className="-mr-1 ml-2 h-5 w-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                </button>
                            </div>

                            {isDropdownOpen && (
                                <div className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                                    <div className="py-1">
                                        {transactions.map((transaction, index) => (
                                            <button
                                                key={index}
                                                onClick={() => {
                                                    loadTransactionData(index, transactions, userData);
                                                    setIsDropdownOpen(false);
                                                }}
                                                className={`block w-full text-left px-4 py-2 text-sm ${selectedTransactionIndex === index
                                                    ? "bg-emerald-600 text-white"
                                                    : "text-gray-700 hover:bg-emerald-100"
                                                    }`}
                                            >
                                                {transaction.nom || `Transaction ${index + 1}`}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </SidebarHeader>
                <SidebarBody>
                    <SidebarSection>{renderSidebarContent()}</SidebarSection>
                    <SidebarSpacer />
                </SidebarBody>
                <SidebarFooter>
                    <Dropdown>
                        <DropdownButton as={SidebarItem}>
                            <span className="flex min-w-0 items-center gap-3">
                                <span className="min-w-0">
                                    <span className="block truncate text-sm/5 font-medium text-zinc-950 dark:text-white">{data.user.prenom}</span>
                                    <span className="block truncate text-xs/5 font-normal text-zinc-500 dark:text-zinc-400">{data.user.email}</span>
                                </span>
                            </span>
                            <ChevronUpIcon />
                        </DropdownButton>
                        <DropdownMenu className="min-w-64" anchor="top start">
                            <DropdownItem
                                onClick={() => navigateTo("profil")}
                            >
                                <UserCircleIcon />
                                <DropdownLabel>Profil</DropdownLabel>
                            </DropdownItem>

                            <DropdownDivider />
                            <DropdownItem onClick={() =>
                                memberstack.logout()
                                    .then(({ data, type }) => {
                                        window.location.replace('/');
                                    })}>
                                <ArrowRightStartOnRectangleIcon />
                                <DropdownLabel>Se deconnecter</DropdownLabel>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </SidebarFooter>

            </Sidebar>
        );
    };

    const getContent = () => {
        if (!data) return <Loading />;
        return (
            <TabContent activeTab={currentActiveTab}>
                {getTabPanesByDemarche(data.demarche, data)}
            </TabContent>
        );
    };


    {/** fonctions de refresh */ }
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const shouldRefresh = query.get("refresh");

        const refreshActions = async () => {
            if (
                shouldRefresh !== "1" ||
                !data ||
                !data.transaction ||
                !data.demarche ||
                location.pathname !== "/app/dashboard" ||
                hasRefreshed.current // 🛑 Si déjà fait, on sort
            ) return;

            hasRefreshed.current = true; // ✅ On bloque les prochains appels

            try {
                console.log("🔄 Rafraîchissement des actions déclenché par ?refresh=1");

                const transactionId = data.transactionId || data.transaction.id || data.transaction.ID;
                const refreshedActions = await fetchRecordsFields("actions", transactionId, "transaction");

                setData((prev) => ({
                    ...prev,
                    action: refreshedActions || [],
                }));

                // ✅ Supprimer `refresh=1` de l’URL
                const query = new URLSearchParams(location.search);
                query.delete("refresh");
                const newSearch = query.toString();
                const newUrl = `${location.pathname}${newSearch ? "?" + newSearch : ""}`;
                window.history.replaceState({}, document.title, newUrl);

                console.log("✅ Actions mises à jour et URL nettoyée");
            } catch (error) {
                console.error("❌ Erreur lors du rechargement des actions :", error);
            }
        };

        refreshActions();
    }, [location, data]);

    {/** gestion des routes */ }
    useEffect(() => {
        if (!data || !data.demarche) return;
      
        let route = "/app/dashboard"; // valeur par défaut
        switch (data.demarche) {
          case "mariage":
            route = "/app/dashboard-mariage";
            break;
            case "pacs":
            route = "/app/dashboard-pacs";
            break;
          case "pma":
            route = "/app/dashboard-pma";
            break;
          case "donation":
            route = "/app/dashboard-donation";
            break;
          case "aucune_demarche":
            route = "/app/dashboard-empty";
            break;
          case "transaction":
          case "transaction_vendeur":
            route = "/app/dashboard"; // déjà OK
            break;
        }
      
        if (location.pathname !== route) {
          navigate(route, { replace: true }); // ⬅️ évite un retour inutile dans l'historique
        }
      }, [data?.demarche]); // ⬅️ Dépend de la détection de la démarche

    //console.log("data", data)
    return (

        <SidebarLayout sidebar={getSidebar()} navbar={<Navbar />}>
            {getContent()}
        </SidebarLayout>
    );
}

export default Layout;